import num1 from './images/1.jpg';
import num2 from './images/2.jpg';
import num3 from './images/3.jpg';
import num4 from './images/4.jpg';
import num5 from './images/5.jpg';
import num6 from './images/6.jpg';
import num7 from './images/7.jpg';
import num8 from './images/8.jpg';
import num9 from './images/9.jpg';
import num10 from './images/10.jpg';
import num11 from './images/11.jpg';
import num12 from './images/12.jpg';
import num13 from './images/13.jpg';
import num14 from './images/14.jpg';
import num15 from './images/15.jpg';
import num16 from './images/16.jpg';
import num17 from './images/17.jpg';
import num18 from './images/18.jpg';
import num19 from './images/19.jpg';
import num20 from './images/20.jpg';
import num21 from './images/21.jpg';
import num22 from './images/22.jpg';
import num23 from './images/23.jpg';
import num24 from './images/24.jpg';
import num25 from './images/25.jpg';
import num26 from './images/26.jpg';
import num27 from './images/27.jpg';
import num28 from './images/28.jpg';
import num29 from './images/29.jpg';
import num30 from './images/30.jpg';
import num31 from './images/31.jpg';
import num32 from './images/32.jpg';
import num33 from './images/33.jpg';
import num34 from './images/34.jpg';
import num35 from './images/35.jpg';
import num36 from './images/36.jpg';
import num37 from './images/37.jpg';



    const Items = [
        {img: num1},
        {img: num2},
        {img: num3},
        {img: num4},
        {img: num5}, 
        {img: num6},
        {img: num7},
        {img: num8},
        {img: num9},
        {img: num10},
        {img: num11},
        {img: num12},
        {img: num13},
        {img: num14},
        {img: num15},
        {img: num16},
        {img: num17},
        {img: num18},
        {img: num19},
        {img: num20},
        {img: num21},
        {img: num22},
        {img: num23},
        {img: num24},
        {img: num25},
        {img: num26},
        {img: num27},
        {img: num28},
        {img: num29},
        {img: num30},
        {img: num31},
        {img: num32},
        {img: num33},
        {img: num34},
        {img: num35},
        {img: num36},
        {img: num37},


      ];

      export default Items;